import { History } from 'history';
import { Dispatch } from 'redux';
import { activeFiltersSelector, activeInfoFilterSelector } from '../../reducers/SimulationReducer/FiltersReducer/FiltersSelector';
import { SIMULATE } from '../../shared/constants';
import { SimulationFilterWithRouter } from '../../reducers/SimulationReducer/FiltersReducer/FiltersReducer.types';

import { editorRouterFiltersConfig, SIMULATION_FILTERS_WITH_ROUTER } from '../../reducers/SimulationReducer/FiltersReducer/FiltersConfig';
import { StateType } from '../../reducers';

// extracted to separate file to avoid circular imports
export const fixPathAfterFiltersChange = (history: History<unknown>) => (dispatch: Dispatch<any>, getState: () => StateType) => {
  const state = getState();

  const activeInfoFilter = activeInfoFilterSelector(state) as SimulationFilterWithRouter | undefined;

  const routerConfig = activeInfoFilter && editorRouterFiltersConfig[activeInfoFilter];

  if (routerConfig && !routerConfig.isPathnameCorrect(history.location.pathname)) {
    history.replace(routerConfig.pathnameSelector(state) as string);
    return;
  }

  const activeFilters = activeFiltersSelector(state);

  if (!activeFilters?.get(SIMULATION_FILTERS_WITH_ROUTER.dataExplorer) && !activeFilters?.get(SIMULATION_FILTERS_WITH_ROUTER.learn)) {
    history.replace(SIMULATE);
  }
};
